import { useEffect } from 'react'
import { useScanner } from '../useScanner'

/**
 * The viewfinder for makers' serials. Its own component so that closing it
 * unmounts `useScanner`, which is what releases the camera.
 *
 * It starts itself: opening it was the request. The scanner reads QR codes; a
 * maker's 1D barcode needs the USB scanner, or the number typed.
 */
export function MakerCamera({ onScan }: { onScan: (raw: string) => void }): JSX.Element {
  const scanner = useScanner(onScan)
  const { start, supported } = scanner
  useEffect(() => {
    if (supported) start()
  }, [supported, start])

  return (
    <div className="stack inv-camera">
      <div className="scanner">
        <video ref={scanner.videoRef} playsInline muted />
        {scanner.running ? <div className="reticle" /> : null}
        <p className="scan-hint">
          {scanner.running ? 'Point at the next serial' : scanner.starting ? 'Starting the camera…' : 'Camera off'}
        </p>
      </div>
      {scanner.unavailable ? <p className="muted inv-quiet">{scanner.unavailable}</p> : null}
      {scanner.error ? <p className="critical">{scanner.error}</p> : null}
      <p className="muted inv-quiet">Reads QR codes. For a barcode, use the USB scanner or type the number.</p>
    </div>
  )
}
